export const navItems = [
  {
    id: 'stuff',
    title: 'My Stuff',
    items: [
      {
        path: '/projects',
        emoji: '🗂️',
        label: 'Projects',
        icon: 'IconFolder',
      },
    ],
    flavour: 'users-only',
    site: 'web',
  },
  {
    id: 'root',
    title: '',
    items: [
      {
        path: '/playground/blank',
        emoji: '',
        label: 'Create',
        icon: 'Icon360View',
      },
      { path: '/browse', emoji: '', label: 'Browse Ideas', icon: 'IconLamp' },
      { path: '/generators', emoji: '⚡', label: 'Generators', icon: 'IconBolt' },
      {
        path: '/special',
        emoji: '⚡',
        label: 'Special Offer',
        icon: 'IconGift',
        flavour: 'free-only',
      },
      // { path: '/asset-packs', emoji: '📦', label: 'Examples', icon: 'IconPackage' },
    ],
    flavour: 'v2',
    site: 'web',
  },
  {
    id: 'sloyd',
    title: 'Admin',
    flavour: 'sloyd-only',
    site: 'web',
    items: [
      // {
      //   path: '/platform/',
      //   emoji: '⚡',
      //   label: 'Platform',
      //   icon: 'IconPlayerRecord',
      // },
      // {
      //   path: '/recorder/181',
      //   emoji: '⚡',
      //   label: 'Recorder',
      //   icon: 'IconPlayerRecord',
      // },
      {
        path: '/labs/quality',
        emoji: '⚡',
        label: 'Quality',
        icon: 'IconTestPipe',
      },
      {
        path: '/materials',
        emoji: '⚡',
        label: 'Materials',
        icon: 'IconWall',
      },

      {
        path: '/backdrops',
        emoji: '⚡',
        label: 'Backdrops',
        icon: 'IconPhoto',
      },
      {
        path: '/labs/goldens',
        emoji: '⚡',
        label: 'Goldens',
        icon: 'IconStar',
      },
      {
        path: '/changelog',
        emoji: '⚡',
        label: 'Changelog',
        icon: 'IconList',
      },

      // {
      //   path: '/labs/analytics',
      //   emoji: '',
      //   label: 'Try Analytics',
      //   icon: 'IconFlask2',
      // },
    ],
  },
  {
    id: 'tools',
    title: 'Tools (labs)',
    site: 'web',
    items: [
      {
        path: '/labs/image-to-3d',
        emoji: '🖼️',
        label: 'Image to 3D',
        icon: 'IconCamera',
      },
      {
        path: '/labs/text-to-3d',
        emoji: '🖼️',
        label: 'Text to 3D',
        icon: 'Icon3dCubeSphere',
        flavour: 'sloyd-only',
        badge: 'soon',
      },
      {
        path: '/labs/material-studio',
        emoji: '🛠️',
        label: 'Material Studio',
        icon: 'IconHammer',
        flavour: 'hidden',
      },
      // {
      //   path: '/labs/three',
      //   emoji: '⚙️',
      //   label: 'Animation',
      //   icon: 'IconMovie',
      //   flavour: 'sloyd-only',
      // },
      // {
      //   path: '/labs/scene',
      //   emoji: '⚙️',
      //   label: 'Scene Builder',
      //   icon: 'IconMovie',
      //   flavour: 'sloyd-only',
      // },
      {
        path: '/labs/guassian',
        emoji: '',
        label: 'Splatting',
        icon: 'Icon360View',
        flavour: 'hidden',
      },
      {
        path: '/json',
        emoji: '',
        label: 'Json Editor',
        icon: 'IconCode',
        flavour: 'hidden',
      },
      {
        path: 'https://app.sloyd.ai/',
        emoji: '',
        label: 'Parametric AI Editor',
        icon: 'Icon360View',
        flavour: 'slim-only',
      },
    ],
  },
  {
    id: 'learn',
    title: 'Learn & More',
    site: 'web',
    items: [
      // { path: '/tutorials', emoji: '📚', label: 'Tutorials', icon: 'IconBook' },
      { path: '/alpha', emoji: '🗨️', label: 'Join V2', icon: 'IconSun', flavour: 'slim-only' },
      { path: '/docs', emoji: '📖', label: 'Docs', icon: 'IconBook2', flavour: 'v2' },
      {
        path: '/discord',
        emoji: '🗨️',
        label: 'Community',
        icon: 'IconMessageCircle',
        flavour: 'v2',
      },
    ],
  },
];
